import React, { useContext } from "react";
import { FaChevronLeft } from "react-icons/fa";
import { DisplayDiscussionForMiniScreenContext } from "../../contexts/DisplayDiscussionForMiniScreenContext";
import { BsSearch } from "react-icons/bs";
import { RxCross2 } from "react-icons/rx";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import Person from "../Person";
import { Link } from "react-router-dom";

export default function InterlocuteurInfo({ show, setShow, enleverRecherche, isTyping, currentUserRole, inboxRecipientPermissions }) {
  const {
    setDisplayDiscussionForMiniScreen,
    destinataire,
    setDestinataire,
    setActiveRoomIdInbox,
  } = useContext(DisplayDiscussionForMiniScreenContext);
  const canNotWriteToOwner = currentUserRole === "owner" && inboxRecipientPermissions && !inboxRecipientPermissions.includes("CAN_WRITE_A_MESSAGE_TO_OWNER");

  return (
    <>
      <ul className="tyn-list-inline d-md-none ms-n1">
        <li>
          <button
            className="btn btn-icon btn-md btn-pill btn-transparent js-toggle-main"
            onClick={() => {
              setActiveRoomIdInbox("");
              setDestinataire(null);
              setDisplayDiscussionForMiniScreen(false);
            }}
          >
            <FaChevronLeft />
          </button>
        </li>
      </ul>
      <div className="tyn-media-group">
        <div className="tyn-media tyn-size-lg d-none d-sm-inline-flex">
          <Link
            to={`/contact/${destinataire.username}`}
            style={{ height: "100%", width: "100%" }}
          >
            <Person
              person={{
                image: destinataire.userImage,
                nom: destinataire.nom,
                prenom: destinataire.prenom,
                userId: destinataire.userId,
                colors: destinataire.color,
              }}
            />
          </Link>
        </div>

        <div className="tyn-media tyn-size-rg d-sm-none">
          <Link
            to={`/contact/${destinataire.username}`}
            style={{ height: "100%", width: "100%" }}
          >
            <Person
              person={{
                image: destinataire.userImage,
                nom: destinataire.nom,
                prenom: destinataire.prenom,
                userId: destinataire.userId,
                colors: destinataire.color,
              }}
            />
          </Link>
        </div>

        <div className="tyn-media-col">
          {canNotWriteToOwner && (
            <div className="tyn-media-row mb-1">
              <small className="text-danger" style={{ fontSize: "0.7rem" }}>
                ⚠ Cet utilisateur ne peut pas vous écrire —{" "}
                <Link to="/workspace/settings" className="text-danger fw-bold text-decoration-underline">
                  Modifier
                </Link>
              </small>
            </div>
          )}
          <div className="tyn-media-row">
            <h6 className="name">
              {destinataire.prenom}{" "}
              <span className="d-none d-sm-inline-block">
                {destinataire.nom}
              </span>
            </h6>
          </div>
          <div className="tyn-media-row has-dot-sap">
            <span
              className={`meta text-success ${
                isTyping ? "my-text-writting-alternate-infinite" : ""
              }`}
            >
              {isTyping ? "Écrit..." : ""}
            </span>
          </div>
        </div>
      </div>
      {!enleverRecherche ? (
        <div
          className={`tyn-chat-search ${show ? "active" : ""}`}
          id="tynChatSearch"
        >
          <div className="flex-grow-1">
            <div className="form-group">
              <div className="form-control-wrap form-control-plaintext-wrap">
                <div className="form-control-icon start">
                  <BsSearch />
                </div>
                <input
                  type="text"
                  className="form-control form-control-plaintext"
                  id="searchInThisChat"
                  placeholder="Recherchez un méssage"
                />
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center gap gap-3">
            <ul className="tyn-list-inline ">
              <li>
                <button className="btn btn-icon btn-sm btn-transparent">
                  <FaChevronUp />
                </button>
              </li>
              <li>
                <button className="btn btn-icon btn-sm btn-transparent">
                  <FaChevronDown />
                </button>
              </li>
            </ul>
            <ul className="tyn-list-inline ">
              <li>
                <button
                  className="btn btn-icon btn-md btn-light js-toggle-chat-search"
                  onClick={() => setShow(false)}
                >
                  <RxCross2 />
                </button>
              </li>
            </ul>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
